














import Vue from "vue";
import KeyboardKey from "./KeyboardKey.vue";
import { handleKeyPress } from "../../services/inputservice";



export default Vue.extend({
    name: "KeyboardGrid",
    components: {
        KeyboardKey
    },
    mounted() {
        Vue.nextTick(() => {

            window.addEventListener("keydown", handleKeyPress);
        })

    },
    beforeDestroy() {

        window.removeEventListener("keydown", handleKeyPress);
    },
})



